import React, { useState, useEffect } from "react";
import { Checkbox, List, Divider } from "@mui/material";
import theme from "theme";
import { apiGet } from "api/callApi";
import TooltipText from "components/TooltipText";
import SC from "./style";

const OccupantList = (props) => {
  const {
    searchQuery,
    levelData,
    setSelectedItems = () => {},
    selectedItems,
  } = props;
  const [selectAll, setSelectAll] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Effect to fetch data when levelData changes
  useEffect(() => {
    if (levelData.id) {
      getOccupants(levelData.id);
    }
  }, [levelData]);

  const getOccupants = async (levelId) => {
    if (!levelId) return;
    try {
      setLoading(true);
      const response = await apiGet(
        `/v1/getoccupantoptions?levelId=${levelId}`,
        false
      );
      setData(response?.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    // If "Select All" is checked, add all occupant ids to selectedItems
    if (isChecked) {
      // Add only IDs from `data` that are not already in `selectedItems`
      const newIds = data
        .filter((item) => !selectedItems.includes(item.id))
        .map((item) => item.id);
      setSelectedItems((prevSelectedItems) => [
        ...prevSelectedItems,
        ...newIds,
      ]);
    } else {
      // If "Select All" is unchecked, remove only those IDs that are in the current data
      const remainingIds = selectedItems.filter(
        (item) => !data.some((dataItem) => dataItem.id === item) // Keep items that are not in data
      );
      setSelectedItems(remainingIds); // Update selectedItems by removing checked items
    }
  };

  const handleSelect = (event, id) => {
    const isChecked = event.target.checked;

    // If the checkbox is checked and ID is not in selectedItems, push it
    if (isChecked) {
      if (!selectedItems.includes(id)) {
        setSelectedItems((prev) => [...prev, id]); // Push ID into selectedItems
      }
    } else {
      // If unchecked, filter out the ID from selectedItems
      setSelectedItems((prev) => prev.filter((item) => item !== id)); // Remove ID from selectedItems
    }
  };

  // Check if the "Select All" checkbox should be checked
  useEffect(() => {
    if (data.length > 0) {
      const allSelected = data.every((item) => selectedItems.includes(item.id));
      setSelectAll(allSelected);
    }
  }, [selectedItems, data]);

  const filterdata = data.filter((item) =>
    item?.occupantName?.toLowerCase().includes(searchQuery)
  );

  return (
    <SC.Container>
      {data.length > 0 && (
        <>
          <div
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
            }}
          >
            <span>
              <Checkbox
                checked={selectAll}
                onChange={handleSelectAllChange}
                sx={{
                  "&.Mui-checked": {
                    color: theme.colors.themeColor,
                  },
                }}
                size="small"
              />

              <TooltipText
                title={levelData?.name || ""}
                style={{ fontWeight: "bold", fontSize: "14px" }}
                maxLength={80}
              />
            </span>
          </div>
          <Divider />
          <List
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            {filterdata.length > 0 ? (
              filterdata.map((item) => (
                <div
                  key={item.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Checkbox
                    checked={selectedItems.includes(item.id)}
                    onChange={(event) => handleSelect(event, item.id)}
                    sx={{
                      "&.Mui-checked": {
                        color: theme.colors.themeColor,
                      },
                    }}
                    size="small"
                  />

                  <span style={{ fontSize: "12px", width: "100%" }}>
                    {item.occupantName}-{item.occupantNo}
                  </span>
                </div>
              ))
            ) : (
              <span
                style={{ color: "gray", fontSize: "12px", marginLeft: "10px" }}
              >
                Occupant not found{" "}
              </span>
            )}
          </List>
        </>
      )}
    </SC.Container>
  );
};

export default OccupantList;
